import { supabase } from './supabaseClient';

/**
 * Admin Service
 * Handles admin-related functionality such as checking admin status
 */
export const adminService = {
    /**
     * Check if a user is an admin
     * @param userId - The user ID to check
     * @returns Promise<boolean> - true if user is admin, false otherwise
     */
    async isUserAdmin(userId: string): Promise<boolean> {
        if (!userId) return false;

        try {
            const { data, error } = await supabase
                .from('users')
                .select('role')
                .eq('id', userId)
                .single();

            if (error) {
                console.error('Error checking admin status:', error);
                return false;
            }

            return data?.role === 'admin';
        } catch (error) {
            console.error('Exception checking admin status:', error);
            return false;
        }
    }
};
